module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-18-c4a4d75410c16ba7ad570d16e56c418a.jpg";